export default [
  {
    name: 'Pre seed',
    stage: 'Early stage',
    description:
      'A pre-seed round is a pre-institutional seed round that either has no institutional investors or is a very low amount, often below $150k.',
    average: 0.3,
    median: 0.1,
  },
  {
    name: 'Non-equity assistance',
    stage: 'Early stage',
    description:
      'A non-equity assistance round occurs when a company or investor provides office space or mentorship and does not get equity in return.',
    average: 0.6,
    median: 0.1,
  },
  {
    name: 'Angel',
    stage: 'Early stage',
    description:
      'An angel round is typically a small round designed to get a new company off the ground. Investors in an angel round include individual angel investors, angel investor groups, friends, and family.',
    average: 0.9,
    median: 0.5,
  },
  {
    name: 'Seed',
    stage: 'Early stage',
    description:
      'Seed rounds are among the first rounds of funding a company will receive, generally while the company is young and working to gain traction. Round sizes range between $10k–$2M, though larger seed rounds have become more common in recent years. A seed round typically comes after an angel round (if applicable) and before a company’s Series A round.',
    average: 1.2,
    median: 0.5,
  },
  /*
    {
        name: 'Convertible note',
        stage: 'Early stage',
        description: "A convertible note is an ‘in-between’ round funding to help companies hold over until they want to raise their next round of funding. When they raise the next round, this note ‘converts’ with a discount at the price of the new round. You will typically see convertible notes after a company raises, for example, a Series A round but does not yet want to raise a Series B round.",
        average: 3.1,
        median: 0.3
    },
    */
  {
    name: 'Series A',
    stage: 'Early stage',
    description:
      'Series A rounds are funding rounds for earlier stage companies and range on average between $1M–$30M.',
    average: 9.8,
    median: 5,
  },
  {
    name: 'Series B',
    stage: 'Early stage',
    description:
      'Series B rounds are funding rounds for earlier stage companies and range on average between $1M–$30M.',
    average: 28.1,
    median: 12,
  },
  /*
    {
        name: 'Initial coin offering (ICO)',
        stage: 'Early stage',
        description: 'An initial coin offering (ICO) is a means of raising money via crowdfunding using cryptocurrency as capital. A company raising money through an ICO holds a fundraising campaign, and during this campaign, backers will purchase a percentage of a new cryptocurrency (called a "token" or "coin"), often using another cryptocurrency like Bitcoin to make the purchase, in the hopes that the new cryptocurrency grows in value.',
        average: 28.7,
        median: 9
    },
    */
  {
    name: 'Series C',
    stage: 'Later stage',
    description:
      'Series C rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 36.7,
    median: 19.6,
  },
  {
    name: 'Series D',
    stage: 'Later stage',
    description:
      'Series D rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 55.6,
    median: 25,
  },
  {
    name: 'Series E',
    stage: 'Later stage',
    description:
      'Series E rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 78.6,
    median: 30,
  },
  {
    name: 'Series F',
    stage: 'Later stage',
    description:
      'Series F rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 125.6,
    median: 42.6,
  },
  {
    name: 'Series G',
    stage: 'Later stage',
    description:
      'Series G rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 199.3,
    median: 55.2,
  },
  {
    name: 'Series H',
    stage: 'Later stage',
    description:
      'Series H rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 259.3,
    median: 110,
  },
  {
    name: 'Series I',
    stage: 'Later stage',
    description:
      'Series I rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 165.5,
    median: 76.3,
  },
  {
    name: 'Series J',
    stage: 'Later stage',
    description:
      'Series J rounds and onwards are for later stage and more established companies. These rounds are usually $10M+ and are often much larger.',
    average: 363.5,
    median: 93.6,
  },
  /*
  {
    name: 'Secondary market',
    stage: 'Later stage',
    description:
      'A secondary market transaction is a fundraising event in which one investor purchases shares of stock in a company from other, existing shareholders rather than from the company directly. These transactions often occur when a private company becomes highly valuable and early stage investors or employees want to earn a profit on their investment, and these transactions are rarely announced or publicized.',
    average: 237.6,
    median: 41.3,
  },
  {
    name: 'Grant',
    stage: 'Later stage',
    description:
      'A grant is when a company, investor, or government agency provides capital to a company without taking an equity stake in the company.',
    average: 2.5,
    median: 0.1,
  },
  {
    name: 'Debt financing',
    stage: 'Later stage',
    description:
      'In a debt round, an investor lends money to a company, and the company promises to repay the debt with added interest.',
    average: 33.9,
    median: 1.5,
  },
  */
  {
    name: 'Corporate round',
    stage: 'Later stage',
    description:
      'A corporate round occurs when a company, rather than a venture capital firm, makes an investment in another company. These are often, though not necessarily, done for the purpose of forming a strategic partnership.',
    average: 75.3,
    median: 4.3,
  },
  /*
  {
    name: 'Post-IPO equity',
    stage: 'Later stage',
    description:
      'A post-IPO equity round takes place when firms invest in a company after the company has already gone public.',
    average: 79.7,
    median: 8.2,
  },
  */
  {
    name: 'Private equity',
    stage: 'Later stage',
    description:
      'A private equity round is led by a private equity firm or a hedge fund and is a late stage round. It is a less risky investment because the company is more firmly established, and the rounds are typically upwards of $50M.',
    average: 131.9,
    median: 38,
  },
  /*
  {
    name: 'Post-IPO debt',
    stage: 'Later stage',
    description:
      'A post-IPO debt round takes place when firms loan a company money after the company has already gone public. Similar to debt financing, a company will promise to repay the principal as well as added interest on the debt.',
    average: 254.2,
    median: 25.2,
  },
  {
    name: 'Post-IPO secondary',
    stage: 'Later stage',
    description:
      'A post-IPO secondary round takes place when an investor purchases shares of stock in a company from other, existing shareholders rather than from the company directly, and it occurs after the company has already gone public.',
    average: 417.6,
    median: 209,
  },
  */
];
